import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AuthContext from "@/contexts/AuthContext";

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (!localStorage.getItem("accessToken")) {
      navigate("/usuarios/login");
    }
  }, [pathname, search]);

  return (
    <AuthContext.Provider value={!!localStorage.getItem("accessToken")}>
      {children}
    </AuthContext.Provider>
  );
};
